import Vue from "vue";
import VueRouter from "vue-router";
import ViewmedicaBrochureIndex from "../views/Index.vue";
import i18n from "@/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:client/:file/:language/:version?",
    name: "viewmedica-brochure-index",
    component: ViewmedicaBrochureIndex,
    meta: {
      title: "ViewMedica Brochure"
    }
  },

  {
    path: "/400",
    name: "error-400",
    component: () => import(/* webpackChunkName: "404" */ "../views/400.vue"),
    meta: {
      title: "ViewMedica Brochure - Missing Parameters"
    }
  },

  {
    path: "/403",
    name: "error-403",
    component: () => import(/* webpackChunkName: "404" */ "../views/403.vue"),
    meta: {
      title: "ViewMedica Brochure - Account Inactive"
    }
  },

  {
    path: "/404",
    name: "error-404",
    component: () => import(/* webpackChunkName: "404" */ "../views/404.vue"),
    meta: {
      title: "ViewMedica Brochure - Not Found"
    }
  },

  {
    path: "/500",
    name: "error-500",
    component: () => import(/* webpackChunkName: "404" */ "../views/500.vue"),
    meta: {
      title: "ViewMedica Brochure - Not Found"
    }
  },

  {
    path: "/*/*",
    redirect: "/400"
  },

  {
    path: "/*",
    redirect: "/400"
  },

  {
    path: "*",
    redirect: "/404"
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  console.log(to.params, i18n);
  if (to.params && to.params.language && i18n.locale !== to.params.language) {
    i18n.locale = to.params.language;
    document.querySelector("html").lang = to.params.language;
  }

  next();
});

export default router;
